import script from "./customFieldList.vue?vue&type=script&setup=true&lang=js"
export * from "./customFieldList.vue?vue&type=script&setup=true&lang=js"

import "./style.css?vue&type=style&index=0&id=36999212&scoped=true&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36999212"]])

export default __exports__